export function parseMoneyBR(value: unknown): number | null {
  if (value === null || value === undefined) return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;

  if (typeof value !== "string") return null;

  const s = value.trim();
  if (!s) return null;

  let normalized = s.replace(/\s/g, "").replace(/R\$/gi, "");
  if (!normalized) return null;
  if (!/^[\d.,]+$/.test(normalized)) return null;

  const commaCount = (normalized.match(/,/g) || []).length;
  if (commaCount > 1) return null;

  if (commaCount === 1) {
    const ptPattern = /^\d{1,3}(?:\.\d{3})*(?:,\d{1,2})?$/;
    if (!ptPattern.test(normalized)) return null;
    normalized = normalized.replace(/\./g, "").replace(",", ".");
  } else {
    const thousandPattern = /^\d{1,3}(?:\.\d{3})+$/;
    if (thousandPattern.test(normalized)) {
      normalized = normalized.replace(/\./g, "");
    } else {
      const decimalPattern = /^\d+(?:\.\d{1,2})?$/;
      if (!decimalPattern.test(normalized)) return null;
    }
  }

  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
}
